'use client'

import Image, {StaticImageData} from 'next/image'
import clsx from 'clsx'
import IconsMarquee from 'v1/common-components/icons-marquee/IconsMarquee'
import {heroMarqueeImages} from 'v1/content/home-page'
import classes from './styles.module.css'
import React, {useEffect, useState} from 'react'

interface HeroLayoutProps {
  leftTextBox: React.ReactNode
  ImageSrc: StaticImageData
  style?: React.CSSProperties
  heroContainerClass?: string
  imageContainerClass?: string
  showMarquee?: boolean
  mobileHeroImage?: StaticImageData
}

export default function HeroLayoutWithImage({
  leftTextBox,
  ImageSrc,
  style,
  imageContainerClass,
  heroContainerClass,
  showMarquee = true,
  mobileHeroImage,
}: HeroLayoutProps) {
  const [isMobile, setIsMobile] = useState<boolean | null>(null)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600)
    }

    // Initial check
    handleResize()

    // Add resize listener
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <section className={classes.heroSection}>
      <div style={style} className={clsx(classes.heroSectionContainer, heroContainerClass)}>
        {leftTextBox}
        <div className={clsx(classes.heroImageContainer, imageContainerClass)}>
          <Image
            loading="lazy"
            className={classes.heroImage}
            src={
              isMobile === null
                ? ImageSrc
                : isMobile && mobileHeroImage
                ? mobileHeroImage
                : ImageSrc
            }
            alt="hero-image"
          />
        </div>
      </div>
      {showMarquee && (
        <div>
          <IconsMarquee
            animate={{x: ['0%', '-50%']}}
            list={[...heroMarqueeImages, ...heroMarqueeImages]}
            iconBoxClass={classes.marqueeLogoBox}
            customMarqueeContainer={classes.heroMarqueeContainer}
          />
        </div>
      )}
    </section>
  )
}
